export default "__VITE_ASSET__2yk2UlJm__"